import React from 'react';
import { useDispatch } from 'react-redux';

import { Stockmovement } from 'services/action';
import { Page } from 'ui/components';
import { Action, Information, Item } from './component/section';

const DetailScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const [data, setData] = React.useState(null);

  const $onLoad = async (e) => {
    const req = await Dispatch(Stockmovement.$show(e));

    if (req?.message === 'success') {
      setData(req?.data);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  return (
    <Page className="detail-fixed bg-white">
      <Page.Header title="Detail Stockmovement" />

      <Page.Body className="d-block px-3">
        <div className="row">
          <div className="col-12 border-sm-none ps-0 pe-0">
            <div className="position-relative">
              <div
                className="position-fixed bg-white border-bottom w-100"
                style={{ zIndex: 1000, paddingRight: 38 }}
              >
                <div className="d-block d-md-flex justify-content-between align-items-center ">
                  <div className="">
                    <h3 className="card-title dx-card-title mb-0 py-2 ps-3">
                      Detail Penerimaan {' '}
                      <span className={`badge status-${data?.document_status}-lt ms-auto `}>
                        {data?.document_status?.replace('_', ' ')?.replace('voided', 'void')}
                      </span>
                    </h3>
                  </div>

                  <Action
                    data={data}
                    onSubmit={() => $onLoad(match?.params?.id)}
                  />
                </div>
              </div>
            </div>

            <div className="mt-5 mt-md-4 p-0 p-md-3 pt-4 pe-0 pe-md-0">
              <Information data={data} />
              <Item data={data} />
            </div>
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default DetailScreen;
